const LOGIN_HOME = '/login-agency';

export const LOGIN_AGENCY_ROUTES = {
  index: LOGIN_HOME,
};
